<app-page-panel 
        [showBackButton]="true"
        iconNameFontAwesome="info"
        pageTitle="Risiken und Chancen"
        [showHistoryButton]="true"
        [showDetailsButton]="false"
        [showBackColor]="true"
        (backButtonClicked)="BackButtonClick()"
		[iconMenuButtons]="navigationService.iconMenuItems"
		[iconMenuOffset]="'..'"

    >  
    <dx-data-grid fxFill
        [allowColumnResizing]="true"
        [rowAlternationEnabled]="true"
        [allowColumnReordering]="true"
        [hoverStateEnabled]="true"
        [noDataText]="''"
        [height]="'calc(100vh - 146px)'"        
        [dataSource]="dataRisikenChancen()"
        (onContentReady)="ContentReady($event)"
        (onRowDblClick)="RisikenDataGridRowDblClick($event)"
        >
        <dxi-column dataField="rcId" caption="ID" [width]="80" [visible]="false" alignment="left"></dxi-column>
        <dxi-column dataField="beschreibung" caption="Beschreibung" alignment="left" minWidth="250" [allowEditing]="false"></dxi-column>
        <dxi-column caption="Bruttorisiko / Bruttochance">
            <dxi-column dataField="hoehe" caption="Höhe" alignment="right" width="120" minWidth="120" [allowEditing]="false">
                <dxo-format type="currency" [precision]="0"></dxo-format>
            </dxi-column>
            <dxi-column dataField="eintritt" caption="Eintritt" width="120" minWidth="120" [visible]="true" alignment="right" [allowEditing]="false">
                <dxo-format type="percent" [precision]="0"></dxo-format>
            </dxi-column>
            <dxi-column dataField="erwartungswert" caption="Erwartungswert" width="150" minWidth="150" [visible]="true" alignment="right" [allowEditing]="false">
                <dxo-format type="currency" [precision]="0"></dxo-format>
            </dxi-column>
        </dxi-column>
        <dxi-column caption="Risikosteuerung">
            <dxi-column dataField="maßnahmen" caption="Maßnahmenbeschreibung" [visible]="true" minWidth="250" alignment="left" [allowEditing]="false"></dxi-column>
        </dxi-column>
        <dxi-column caption="Nettorisiko / Nettochance">
            <dxi-column dataField="nettoHoehe" caption="Höhe" alignment="right" width="120" minWidth="120" [allowEditing]="false">
                <dxo-format type="currency" [precision]="0"></dxo-format>
            </dxi-column>
            <dxi-column dataField="nettoEintritt" caption="Eintritt" width="120" minWidth="120" [visible]="true" alignment="right" [allowEditing]="false">
                <dxo-format type="percent" [precision]="0"></dxo-format>
            </dxi-column>
            <dxi-column dataField="nettoErwartungswert" caption="Erwartungswert" width="150" minWidth="150" [visible]="true" alignment="right" [allowEditing]="false">
                <dxo-format type="currency" [precision]="0"></dxo-format>
            </dxi-column>
        </dxi-column>
        <dxi-column caption="">
            <dxi-column dataField="status" caption="Status" [width]="80" alignment="center" [allowEditing]="false"></dxi-column>
        </dxi-column>
        <dxi-column type="buttons" [width]="60">
            <dxi-button name="edit" icon="more" [hint]="'Details anzeigen'" ></dxi-button>
        </dxi-column>       
        <dxo-toolbar>
            <dxi-item location="before">
                <div *dxTemplate class="info-box">
                    <i class="dx-icon-formula dx-icon-info-box"></i>
                    {{dataCountText()}}
                </div>
            </dxi-item>
            @if(infoText()){
                <dxi-item location="before">
                    <div *dxTemplate class="info-box">
                        <i class="dx-icon-filter dx-icon-info-box"></i>
                        {{infoText()}}
                    </div>
                </dxi-item> 
            }
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="filter"
                        (onClick)="showHeaderFilter.set(!showHeaderFilter())">
                    </dx-button>
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="search" 
                        (onClick)="showFilterRow.set(!showFilterRow())"> 
                    </dx-button>
                </div>
          </dxi-item>
          <dxi-item name="columnChooserButton"></dxi-item>
          <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-group-panel [visible]="false" emptyPanelText=""></dxo-group-panel>
        <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
        <dxo-search-panel [visible]="true" [width]="250" placeholder="Ergebnisliste filtern" ></dxo-search-panel>
        <dxo-header-filter [visible]="showHeaderFilter()" search.enabled="true"></dxo-header-filter>                    
        <dxo-filter-row [visible]="showFilterRow()"></dxo-filter-row>
        <dxo-scrolling mode="virtual" useNative="true" ></dxo-scrolling>
        <dxo-grouping [contextMenuEnabled]="false" [autoExpandAll]="true"></dxo-grouping>
        <dxo-selection mode="single"></dxo-selection>
        <dxo-load-panel [enabled]="true" [showPane]="false"></dxo-load-panel>
        <dxo-pager [visible]="true" displayMode="full" [showNavigationButtons]="true" [showPageSizeSelector]="true"></dxo-pager>
        <dxo-editing
            mode="popup"
            [useIcons]="true" 
            [allowUpdating]="true"
            [allowAdding]="false"
            [allowDeleting]="false">
            <dxo-popup
            title="Risken und Chancen | Details"
            [showTitle]="true"
            width="1200px"
            height="660px">
                <dxi-toolbar-item toolbar = "bottom" location = "after" widget = "dxButton" [options] = "closeButtonOptions">
                </dxi-toolbar-item>
            </dxo-popup>
            <dxo-form [readOnly]="true">
                <dxi-item itemType="group" [colCount]="6" [colSpan]="2">
                    <dxi-item dataField="beschreibung" caption="Beschreibung" [colSpan]="5"></dxi-item>
                    <dxi-item dataField="status" caption="Status" [colSpan]="1"></dxi-item>
                    <dxi-item
                        dataField="maßnahmen"
                        editorType="dxTextArea"
                        [colSpan]="6"                    
                        [editorOptions]="{ height: 200 }">
                    </dxi-item>
                    <dxi-item itemType="group" caption="Bruttorisiko / Bruttochance" [colCount]="3" [colSpan]="6" >
                        <dxi-item dataField="hoehe"></dxi-item>
                        <dxi-item dataField="eintritt"></dxi-item>
                        <dxi-item dataField="erwartungswert"></dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" caption="Nettorisiko / Nettochance" [colCount]="3" [colSpan]="6" >
                        <dxi-item dataField="nettoHoehe"></dxi-item>
                        <dxi-item dataField="nettoEintritt"></dxi-item>
                        <dxi-item dataField="nettoErwartungswert"></dxi-item>
                    </dxi-item>
                </dxi-item>
            </dxo-form>
        </dxo-editing>        
    </dx-data-grid>
</app-page-panel>   